<template>
  <div id="app">
    <Header :navList="navList"></Header>
    <router-view />
    <Footer :navList="navList"></Footer>
  </div>
</template>
<script>
import Header from "./components/header/header.vue";
import Footer from "./components/footer/footer.vue";

import { getNavList } from "./api/apis";
export default {
  name: "App",
  data() {
    return {
      navList:[],
    };
  },
  components: {
    Header,
    Footer
  },
  created() {
    //初始化导航数据，存储到store
    getNavList().then(res => {
      let navBanner = [];
      let cate = [];
      let navList = [
        { id: 0, title: "首页", path: "/" },
        { id: 0, title: "业务范围", path: "/busines" },
        { id: 0, title: "公司简介", path: "/brief" },
        { id: 0, title: "工程案例", path: "/casecenter" },
        { id: 0, title: "新闻中心", path: "/newscenter" },
        { id: 0, title: "人才招聘", path: "/talent" },
        { id: 0, title: "联系我们", path: "/concat" }
      ];
      res.forEach((item, index) => {
        navList[index].id = item.id;
        navList[index].title = item.cate_name;
        navBanner[index] = item.cate_img;
        cate.push(item.next_cate);
      });
      this.$store.commit('initNavData',{navList,navBanner,cate});
      this.navList = navList;
    
      // console.log(this.$store.state);
      // console.log(navBanner);
      // console.log(cate);
      // console.log(navList);
    });
  }
};
</script>
<style>
@import "./static/css/index.css";
body,
html {
  background: #f2f2f2;
}
#app {
  /* background: #F2F2F2; */
}
</style>
